/***
*
*   HOMEPAGE
*   Homepage template with features, testimonials and CTA
*
**********/

import React, { Fragment } from 'react';
import { Row, Link, Hero, Features, Testimonial, Animate } from 'components/lib';
import ImgDashboard from './images/deal-finder-preview.jpg';
import ImgKyleGawley from './images/kyle-gawley.jpg';
import Style from './home.module.scss';

export function Home(props){

  return(
    <Fragment>

      <Hero
        title='Olvídate de vender y di Hola a Deal Finder'
        tagline='Porque a todos nos gusta recibir información sobre productos relevantes, ha llegado la revolución en la publicidad para que puedas crear automáticamente las campañas que la gente quiere escuchar'
        image={ ImgDashboard }
        alt="Vista de búsqueda de prospectos en Deal Finder"
      />

      <section className={ Style.hero }>
        <Animate type='pop'>
          <section className={ Style.blurb }>
            <h1>Conoce Deal Finder</h1>
            <h2>Olvídate de buscar prospectos, calificarlos, crear campañas para ellos y medirlas. Deja todo en manos de la Inteligencia Artificial y el Machine Learning.</h2>
          </section>
        </Animate>

        <Row color='white'>
          <Features iconLanding/>
        </Row>

      </section>

      <Row color='brand-muted'>
        <Testimonial
          text='Deal Finder nos ha permitido dar el salto en calidad en nuestro proceso de engagement con los clientes. Ahora les conocemos mucho mejor y podemos crear comunicaciones y productos a su medida.'
          author='Kyle Donald, Marketing Expert'
          image={ ImgKyleGawley }
        />
      </Row>

      {/* <Row title='Conéctate a la revolución en la publicidad' align='center'>
        <Link btn url='/signup' text='Sign Up Now'/>
      </Row> */}
      <section className={ Style.hero }>
        <Animate type='pop'>
          <section className={ Style.blurb }>
            <h1>Conéctate a la revolución en la publicidad</h1>
          </section>
        </Animate>

        {/* <Row color='white'> */}
          <Link btn url='/signup' text='Regístrate' btnBrand/>
        {/* </Row> */}

      </section>
    </Fragment>
  );
}
